<template>
  <b-overlay :show="loading" variant="white" rounded="sm">
    <div>
      <div class="row">
        <div class="col-sm-2">
          <v-select
            v-model="anio"
            :items="anios"
            label="Año"
            dense
            solo
            @change="obtenerInforme()"
          ></v-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="card card-custom card-stretch gutter-b">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark"
                  >Total Montos Pagadas</span
                >
                <span class="text-muted mt-3 font-weight-bold font-size-sm"
                  >Porcentaje de totales</span
                >
              </h3>
            </div>
            <div class="card-body py-0">
              <div class="d-flex justify-content-center">
                <apexchart
                  width="400"
                  type="donut"
                  :options="graficoTotales.options"
                  :series="graficoTotales.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card card-custom card-stretch gutter-b">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark"
                  >Total Montos No Pagadas</span
                >
                <span class="text-muted mt-3 font-weight-bold font-size-sm"
                  >Porcentaje de totales</span
                >
              </h3>
            </div>
            <div class="card-body py-0">
              <div class="d-flex justify-content-center">
                <apexchart
                  width="400"
                  type="donut"
                  :options="graficoTotalesNoPagado.options"
                  :series="graficoTotalesNoPagado.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="">
        <div class="">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder">Pagadas</span>
          </h3>
        </div>
        <div class="row">
          <div class="col-md-2">
            <div
              class="card card-custom bg-success gutter-b"
              style="height: 150px"
            >
              <div class="card-body">
                <span class="svg-icon svg-icon-3x svg-icon-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24" />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="7"
                        y="4"
                        width="3"
                        height="13"
                        rx="1.5"
                      />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="12"
                        y="9"
                        width="3"
                        height="8"
                        rx="1.5"
                      />
                      <path
                        d="M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                      />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="17"
                        y="11"
                        width="3"
                        height="6"
                        rx="1.5"
                      />
                    </g>
                  </svg>
                </span>
                <div v-if="informe"
                  class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
                >
                  {{  informe.totalFormatMonedaAnioPagadoUF }}
                </div>
                <a
                  href="#"
                  class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                  >Total UF</a
                >
              </div>
            </div>
          </div>

          <div class="col-md-2">
            <div
              class="card card-custom bg-success gutter-b"
              style="height: 150px"
            >
              <div class="card-body">
                <span class="svg-icon svg-icon-3x svg-icon-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24" />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="7"
                        y="4"
                        width="3"
                        height="13"
                        rx="1.5"
                      />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="12"
                        y="9"
                        width="3"
                        height="8"
                        rx="1.5"
                      />
                      <path
                        d="M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                      />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="17"
                        y="11"
                        width="3"
                        height="6"
                        rx="1.5"
                      />
                    </g>
                  </svg>
                </span>
                <div v-if="informe"
                  class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
                >
                  {{ informe.totalFormatMonedaAnioPagadoUTM }}
                </div>
                <a
                  href="#"
                  class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                  >Total UTM</a
                >
              </div>
            </div>
          </div>

          <div class="col-md-2">
            <div
              class="card card-custom bg-success gutter-b"
              style="height: 150px"
            >
              <div class="card-body">
                <span class="svg-icon svg-icon-3x svg-icon-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24" />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="7"
                        y="4"
                        width="3"
                        height="13"
                        rx="1.5"
                      />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="12"
                        y="9"
                        width="3"
                        height="8"
                        rx="1.5"
                      />
                      <path
                        d="M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                      />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="17"
                        y="11"
                        width="3"
                        height="6"
                        rx="1.5"
                      />
                    </g>
                  </svg>
                </span>
                <div v-if="informe"
                  class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
                >
                  {{ informe.totalFormatMonedaAnioPagadoUS }}
                </div>
                <a
                  href="#"
                  class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                  >Total US</a
                >
              </div>
            </div>
          </div>

          <div class="col-md-2">
            <div
              class="card card-custom bg-success gutter-b"
              style="height: 150px"
            >
              <div class="card-body">
                <span class="svg-icon svg-icon-3x svg-icon-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24" />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="7"
                        y="4"
                        width="3"
                        height="13"
                        rx="1.5"
                      />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="12"
                        y="9"
                        width="3"
                        height="8"
                        rx="1.5"
                      />
                      <path
                        d="M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                      />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="17"
                        y="11"
                        width="3"
                        height="6"
                        rx="1.5"
                      />
                    </g>
                  </svg>
                </span>
                <div v-if="informe"
                  class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
                >
                  {{ informe.totalFormatMonedaAnioPagadoEUR }}
                </div>
                <a
                  href="#"
                  class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                  >Total EUR</a
                >
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="card card-custom gutter-b" style="height: 150px">
              <div class="card-body">
                <span class="svg-icon svg-icon-3x svg-icon-success">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24" />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="7"
                        y="4"
                        width="3"
                        height="13"
                        rx="1.5"
                      />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="12"
                        y="9"
                        width="3"
                        height="8"
                        rx="1.5"
                      />
                      <path
                        d="M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                      />
                      <rect
                        fill="#000000"
                        opacity="0.3"
                        x="17"
                        y="11"
                        width="3"
                        height="6"
                        rx="1.5"
                      />
                    </g>
                  </svg>
                </span>
                <div v-if="informe" class="text-dark font-weight-bolder font-size-h2 mt-3">
                  {{ formatearPesos(
                    informe.totalMonedaAnioPagadoUF +
                      informe.totalMonedaAnioPagadoUTM +
                      informe.totalMonedaAnioPagadoUS +
                      informe.totalMonedaAnioPagadoEUR)
                  }}
                </div>
                <a
                  href="#"
                  class="text-muted text-hover-primary font-weight-bold font-size-lg mt-1"
                  >Total</a
                >
              </div>
            </div>
          </div>
        </div>
        <DataTableInformePagados
          :headers="headers"
          :items="informePagados"
          :page.sync="pagination.page"
          :itemKey="itemKey"
          :items-per-page="pagination.page_size"
          hide-default-footer
          :pagination="pagination"
          :pages="pages"
          v-on:fetch-more="fetchMore"
          :loading="loading"
        >
        </DataTableInformePagados>
      </div>
      <div>
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label font-weight-bolder"> No Pagadas</span>
        </h3>
      </div>
      <div class="row">
        <div class="col-md-2">
          <div
            class="card card-custom bg-success gutter-b"
            style="height: 150px"
          >
            <div class="card-body">
              <span class="svg-icon svg-icon-3x svg-icon-white ml-n2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24" />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="7"
                      y="4"
                      width="3"
                      height="13"
                      rx="1.5"
                    />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="12"
                      y="9"
                      width="3"
                      height="8"
                      rx="1.5"
                    />
                    <path
                      d="M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z"
                      fill="#000000"
                      fill-rule="nonzero"
                    />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="17"
                      y="11"
                      width="3"
                      height="6"
                      rx="1.5"
                    />
                  </g>
                </svg>
              </span>
              <div v-if="informe"
                class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
              >
                {{ informe.totalFormatMonedaAnioNoPagadoUF }}
              </div>
              <a
                href="#"
                class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                >Total UF</a
              >
            </div>
          </div>
        </div>

        <div class="col-md-2">
          <div
            class="card card-custom bg-success gutter-b"
            style="height: 150px"
          >
            <div class="card-body">
              <span class="svg-icon svg-icon-3x svg-icon-white ml-n2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24" />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="7"
                      y="4"
                      width="3"
                      height="13"
                      rx="1.5"
                    />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="12"
                      y="9"
                      width="3"
                      height="8"
                      rx="1.5"
                    />
                    <path
                      d="M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z"
                      fill="#000000"
                      fill-rule="nonzero"
                    />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="17"
                      y="11"
                      width="3"
                      height="6"
                      rx="1.5"
                    />
                  </g>
                </svg>
              </span>
              <div v-if="informe"
                class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
              >
                {{ informe.totalFormatMonedaAnioNoPagadoUTM }}
              </div>
              <a
                href="#"
                class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                >Total UTM</a
              >
            </div>
          </div>
        </div>

        <div class="col-md-2">
          <div
            class="card card-custom bg-success gutter-b"
            style="height: 150px"
          >
            <div class="card-body">
              <span class="svg-icon svg-icon-3x svg-icon-white ml-n2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24" />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="7"
                      y="4"
                      width="3"
                      height="13"
                      rx="1.5"
                    />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="12"
                      y="9"
                      width="3"
                      height="8"
                      rx="1.5"
                    />
                    <path
                      d="M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z"
                      fill="#000000"
                      fill-rule="nonzero"
                    />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="17"
                      y="11"
                      width="3"
                      height="6"
                      rx="1.5"
                    />
                  </g>
                </svg>
              </span>
              <div v-if="informe"
                class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
              >
                {{ informe.totalFormatMonedaAnioNoPagadoUS }}
              </div>
              <a
                href="#"
                class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                >Total US</a
              >
            </div>
          </div>
        </div>

        <div class="col-md-2">
          <div
            class="card card-custom bg-success gutter-b"
            style="height: 150px"
          >
            <div class="card-body">
              <span class="svg-icon svg-icon-3x svg-icon-white ml-n2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24" />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="7"
                      y="4"
                      width="3"
                      height="13"
                      rx="1.5"
                    />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="12"
                      y="9"
                      width="3"
                      height="8"
                      rx="1.5"
                    />
                    <path
                      d="M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z"
                      fill="#000000"
                      fill-rule="nonzero"
                    />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="17"
                      y="11"
                      width="3"
                      height="6"
                      rx="1.5"
                    />
                  </g>
                </svg>
              </span>
              <div v-if="informe"
                class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
              >
                {{ informe.totalFormatMonedaAnioNoPagadoEUR }}
              </div>
              <a
                href="#"
                class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                >Total EUR</a
              >
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card card-custom gutter-b" style="height: 150px">
            <div class="card-body">
              <span class="svg-icon svg-icon-3x svg-icon-success">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24" />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="7"
                      y="4"
                      width="3"
                      height="13"
                      rx="1.5"
                    />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="12"
                      y="9"
                      width="3"
                      height="8"
                      rx="1.5"
                    />
                    <path
                      d="M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z"
                      fill="#000000"
                      fill-rule="nonzero"
                    />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="17"
                      y="11"
                      width="3"
                      height="6"
                      rx="1.5"
                    />
                  </g>
                </svg>
              </span>
              <div v-if="informe" class="text-dark font-weight-bolder font-size-h2 mt-3">
                {{ formatearPesos(
                  informe.totalMonedaAnioNoPagadoUF +
                    informe.totalMonedaAnioNoPagadoUTM +
                    informe.totalMonedaAnioNoPagadoUS +
                    informe.totalMonedaAnioNoPagadoEUR
                )
                }}
              </div>
              <a
                href="#"
                class="text-muted text-hover-primary font-weight-bold font-size-lg mt-1"
                >Total</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="">
        <DataTableInformeNoPagados
          :headers="headers"
          :items="informeNoPagados"
          :page.sync="pagination.page"
          :itemKey="itemKey"
          :items-per-page="pagination.page_size"
          hide-default-footer
          :pagination="pagination"
          :pages="pages"
          v-on:fetch-more="fetchMore"
          :loading="loading"
        >
        </DataTableInformeNoPagados>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import { mapState } from "vuex";
import { GET_INFORME } from "@/core/services/store/informe.module";
import Loader from "@/view/content/Loader.vue";
import moment from "moment";
import DataTableInformePagados from "@/view/content/widgets/advance-table/DataTableInformePagados.vue";
import DataTableInformeNoPagados from "@/view/content/widgets/advance-table/DataTableInformeNoPagados.vue";

export default {
  name: "informe",
  components: {
    DataTableInformePagados,
    DataTableInformeNoPagados,
  },
  data() {
    return {
      page: 1,
      pages: 1,
      paginationStart: { page: 1, page_size: 10, totalRecords: 0, filter: "" },
      pagination: {
        page: 1,
        page_size: this.itemsPerPage,
        totalRecords: 0,
        filter: "",
      },
      itemKey: "_Id",
      filterProject: "",
      filterStage: "",
      loading: true,
      mes: 0,
      anio: 0,
      meses: [],
      anios: [],
      informe: null,
      informePagados: [],
      informeNoPagados: [],
      headers: [
        {
          text: "Mes",
          align: "start",
          sortable: true,
          value: "mes",
          width: "250px",
        },
        // { text: "Anio", value: "anio", sortable: false, width: "180px" },
        { text: "Cantidad", value: "cantidad", width: "120px" },
        { text: "Moneda", value: "moneda", sortable: false, width: "250px" },
        { text: "Estado", value: "estado", sortable: false, width: "110px" },
        { text: "ComisionTotal", value: "comisionTotalFormateada" },
      ],
      graficoTotales: {
        options: {
          labels: [],
        },
        series: [],
      },
      graficoTotalesNoPagado: {
        options: {
          labels: [],
        },
        series: [],
      },
    };
  },
  mounted() {
    let fechaActual = new Date();
    let anioActual = fechaActual.getFullYear();
    for (let i = 2019; i <= anioActual; i++) {
      this.anios.push(i);
    }
    this.anio = anioActual;
    this.obtenerInforme();
    this.loading = false;
  },

  methods: {
    fetchMore(query) {
      ////console.log(("fetchMore Booking")
      this.pagination.page = query.page;
      this.pagination.page_size = query.page_size;
      this.page = query.page;
      ////console.log((this.pagination)
      //this.searching();
    },
    formatearPesos(moneda) {
      let monedaFormateada = new Intl.NumberFormat("es-CL");

      // console.log(monedaFormateada.format(moneda));
      return monedaFormateada.format(moneda);
    },
    formatearDolar(moneda) {
      let monedaFormateada = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
      });

      return monedaFormateada.format(moneda);
    },
    obtenerInforme() {
      this.loading = true;
      this.graficoTotales.options.labels.splice(0, this.graficoTotales.options.labels.length)
      this.graficoTotales.series = [];
      this.graficoTotalesNoPagado.options.labels.splice(0, this.graficoTotalesNoPagado.options.labels.length)
      this.graficoTotalesNoPagado.series = [];
      this.$store
        .dispatch(GET_INFORME, { anio: this.anio })
        .then((response) => {
          // console.log(response)
          this.informe = response;

          let total =
            response.totalMonedaAnioPagadoUF +
            response.totalMonedaAnioPagadoUTM +
            response.totalMonedaAnioPagadoUS +
            response.totalMonedaAnioPagadoEUR;

          // console.log(response.totalMonedaAnioPagadoUTM)

          if (response.totalMonedaAnioPagadoUF <= 0) {
            this.graficoTotales.options.labels.push(`UF ${(0).toFixed(1)}%`);
          } else {
            this.graficoTotales.options.labels.push(
              `UF              ${(
                (response.totalMonedaAnioPagadoUTM / total) *
                100
              ).toFixed(3)}%`
            );
          }

          if (response.totalMonedaAnioPagadoUTM <= 0) {
            this.graficoTotales.options.labels.push(`UTM ${(0).toFixed(1)}%`);
          } else {
            this.graficoTotales.options.labels.push(
              `UTM ${(
                (response.totalMonedaAnioPagadoUTM / total) *
                100
              ).toFixed(3)}%`
            );
          }

          if (response.totalMonedaAnioPagadoUS <= 0) {
            this.graficoTotales.options.labels.push(`US ${(0).toFixed(1)}%`);
          } else {
            this.graficoTotales.options.labels.push(
              `US ${((response.totalMonedaAnioPagadoUS / total) * 100).toFixed(
                3
              )}%`
            );
          }

          if (response.totalMonedaAnioPagadoEUR <= 0) {
            this.graficoTotales.options.labels.push(`EUR ${(0).toFixed(1)}%`);
          } else {
            this.graficoTotales.options.labels.push(
              `EUR ${(
                (response.totalMonedaAnioPagadoEUR / total) *
                100
              ).toFixed(3)}%`
            );
          }

          // console.log(this.graficoTotales.options.labels)

          this.graficoTotales.series.push(response.totalMonedaAnioPagadoUF);
          this.graficoTotales.series.push(response.totalMonedaAnioPagadoUTM);
          this.graficoTotales.series.push(response.totalMonedaAnioPagadoUS);
          this.graficoTotales.series.push(response.totalMonedaAnioPagadoEUR);

          let totalNoPagado =
            response.totalMonedaAnioNoPagadoUF +
            response.totalMonedaAnioNoPagadoUTM +
            response.totalMonedaAnioNoPagadoUS +
            response.totalMonedaAnioNoPagadoEUR;

          if (response.totalMonedaAnioNoPagadoUF <= 0) {
            this.graficoTotalesNoPagado.options.labels.push(
              `UF ${(0).toFixed(1)}%`
            );
          } else {
            this.graficoTotalesNoPagado.options.labels.push(
              `UF ${(
                (response.totalMonedaAnioNoPagadoUF / totalNoPagado) *
                100
              ).toFixed(3)}%`
            );
          }

          if (response.totalMonedaAnioNoPagadoUTM <= 0) {
            this.graficoTotalesNoPagado.options.labels.push(
              `UTM ${(0).toFixed(1)}%`
            );
          } else {
            this.graficoTotalesNoPagado.options.labels.push(
              `UTM ${(0).toFixed(1)}%`
            );
          }

          if (response.totalMonedaAnioNoPagadoUS <= 0) {
            this.graficoTotalesNoPagado.options.labels.push(
              `US ${(0).toFixed(1)}%`
            );
          } else {
            this.graficoTotalesNoPagado.options.labels.push(
              `US ${(
                (response.totalMonedaAnioNoPagadoUS / totalNoPagado) *
                100
              ).toFixed(3)}%`
            );
          }

          if (response.totalMonedaAnioNoPagadoEUR <= 0) {
            this.graficoTotalesNoPagado.options.labels.push(
              `EUR ${(0).toFixed(1)}%`
            );
          } else {
            this.graficoTotalesNoPagado.options.labels.push(
              `EUR ${(
                (response.totalMonedaAnioNoPagadoEUR / totalNoPagado) *
                100
              ).toFixed(3)}%`
            );
          }

          this.graficoTotalesNoPagado.series.push(
            response.totalMonedaAnioNoPagadoUF
          );
          this.graficoTotalesNoPagado.series.push(
            response.totalMonedaAnioNoPagadoUTM
          );
          this.graficoTotalesNoPagado.series.push(
            response.totalMonedaAnioNoPagadoUS
          );
          this.graficoTotalesNoPagado.series.push(
            response.totalMonedaAnioNoPagadoEUR
          );

          this.informePagados = response.detalles;

          this.informeNoPagados = response.detalles;
          this.loading = false;
        })
        .catch((res) => {});
    },
    makeToast(append = false, texto, titulo, variant) {
      this.$bvToast.toast(texto, {
        title: titulo,
        autoHideDelay: 5000,
        variant: variant,
        toaster: "b-toaster-top-right",
        appendToast: append,
      });
    },
    getColor(valor) {
      if (valor == "NO CONCILIADO") return "label-light-danger";
      else if (valor == "CONCILIADO") return "label-light-success";
      else if (valor == "REVISAR (SIN DATOS)") return "label-light-primary";
      else if (valor == "DIFERENCIAS") return "label-light-info";
      else return "label-light-success";
    },
  },
  computed: {
    ...mapState({
      details: (state) => state.payment.details,
      errors: (state) => state.errors,
      client: (state) => state.auth.user,
    }),
  },
};
</script>
<style>
.v-data-table-header th span {
  font-size: 12px;
}

tbody .v-input__prepend-inner i {
  font-size: 12px !important;
}
tbody .v-text-field__slot label {
  /* margin-left: 8px !important; */
  /* top: 0px !important; */
  font-size: 12px !important;
}
tbody .v-text-field__slot input {
  /* margin-left: 8px !important; */
  font-size: 12px !important;
}
#modal-asignar-cajero .modal-header {
  border: 0 !important;
}

.tabla-codebase td {
  padding: 0.75rem !important;
  border-bottom: 1px solid #ecf0f3 !important;
}
.tabla-codebase th {
  border-bottom: 1px solid #ecf0f3 !important;
}

.swal2-icon {
  position: relative;
  box-sizing: border-box !important;
  justify-content: center;
  width: 5em;
  height: 5em;
  margin: 1.25em auto 1.875em;
  border: 0.25em solid transparent;
  border-radius: 50%;
  font-family: inherit;
  line-height: 5em;
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.swal2-modal {
  border-radius: 24px;
}
.v-dialog {
  border-radius: 24px;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background-color: #ecf0f3;
}

/* .v-data-table__expanded .v-data-table__expanded__content .headline{
  font-size: 14px !important;
} */
.alertaFecha {
  background-color: rgba(250, 228, 102, 0.432);
}
.errorFecha {
  background-color: rgba(255, 124, 124, 0.342);
}
.validaFecha {
  background-color: rgba(190, 238, 193, 0.432);
}
.text-inverse-primary {
  font-size: 1.3rem !important;
}
</style>
